import {css} from "lit";

export const dividerStyles = css`
    hr {
        margin: 0;
        border: 0;
        border-top: 2px solid var(--sbkCoreColorLightBlue700);
    }
`;